import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'
import baseUrl from '../baseurl'

const _ = require('lodash')

export default {
  actions: {
    getOnionSamplesData({
      commit,
      state
    }, data) {

      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            'Authorization': "bearer " + state.token
          }
        };
        var url = `${baseUrl}/api/onion/sampleinfo/${data.docId}/${data.sampleNo}`
        Axios.get(url, config)
          .then(async resp => {
            if (resp.data.error) {
              commit('showSnackbar', {
                msg: resp.data.msg
              })
              commit('showLoader', false)
              return reject()
            }
            await commit('updateOnionSampleData', {
              ...data,
              content: resp.data.data
            })
            resolve()
          })
          .catch(err => {
            commit('auth_error', err)
            commit('showSnackbar', {
              msg: err
            });
            commit('showLoader', false);

            reject(err)
          })
      })
    },
    getOnionSamplesThreshold({
      commit,
      state
    }, data) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            'Authorization': "bearer " + state.token
          }
        };
        var url = `${baseUrl}/api/onion/sampleinfo/${data.docId}`
        Axios.get(url, config)
          .then(async resp => {
            if (resp.data.error) {
              commit('showSnackbar', {
                msg: resp.data.msg
              })
              commit('showLoader', false)
              return reject()
            }
            await commit('updateOnionSampleThreshold', resp.data.data)
            resolve()
          })
          .catch(err => {
            commit('auth_error', err)
            commit('showSnackbar', {
              msg: err
            });
            commit('showLoader', false);

            reject(err)
          })
      })
    },
    saveOnionSampleInfo({
      state,
      commit
    }, {
      docId,
      sampleNo,
      sample
    }) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            'Authorization': "bearer " + state.token
          }
        };
        let url = `${baseUrl}/api/onion/sampleinfo/${docId}/${sampleNo}`;
        Axios.post(url, sample, config)
          .then(resp => {
            if (resp.data.error) {
              commit('showSnackbar', {
                msg: resp.data.msg
              })
              commit('showLoader', false)
            } else {
              resolve(resp)
            }

          })
          .catch(err => {
            commit('auth_error', err)
            commit('showSnackbar', {
              msg: err
            });
            commit('showLoader', false);
            reject(err)
          })
      })
    },
    getOnionSummary({
      state,
      commit
    }, docId) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            'Authorization': "bearer " + state.token
          }
        };
        var url = `${baseUrl}/api/onion/summary/${docId}`
        Axios.get(url, config)
          .then(async resp => {
            if (resp.data.error) {
              commit('showSnackbar', {
                msg: resp.data.msg
              })
              commit('showLoader', false)
              return reject()
            }
            commit('getOnionSummary', resp.data.data)
            resolve()
          })
          .catch(err => {
            commit('auth_error', err)
            commit('showSnackbar', {
              msg: err
            });
            commit('showLoader', false);

            reject(err)
          })
      })
    },
    ConfirmOnionReport({
      state,
      commit
    }, docId) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            'Authorization': "bearer " + state.token
          }
        };
        let url = `${baseUrl}/api/onion/report/${docId}/confirm`;
        Axios.put(url, {}, config)
          .then(resp => {
            if (resp.data.error) {
              commit('showSnackbar', {
                msg: resp.data.msg
              })
              commit('showLoader', false)
            } else {
              resolve(resp)
            }

          })
          .catch(err => {
            commit('auth_error', err)
            commit('showSnackbar', {
              msg: err
            });
            commit('showLoader', false);
            reject(err)
          })
      })
    },
    ApproveOnionReport({
      state,
      commit
    }, docId) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            'Authorization': "bearer " + state.token
          }
        };
        let url = `${baseUrl}/api/onion/report/${docId}/approve`;
        Axios.put(url, {}, config).then(resp => {
            if (resp.data.error) {
              commit('showSnackbar', {
                msg: resp.data.msg
              })
              commit('showLoader', false)
            } else {
              resolve(resp)
            }

          })
          .catch(err => {
            commit('auth_error', err)
            commit('showSnackbar', {
              msg: err
            });
            commit('showLoader', false);
            reject(err)
          })
      })
    },
    getOnionReport({
      state,
      commit
    }, docId) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            'Authorization': "bearer " + state.token
          }
        };
        var url = `${baseUrl}/api/onion/report/${docId}`
        Axios.get(url, config)
          .then(async resp => {
            if (resp.data.error) {
              commit('showSnackbar', {
                msg: resp.data.msg
              })
              commit('showLoader', false)
              return reject()
            }
            commit('getOnionSummary', resp.data.data)
            resolve()
          })
          .catch(err => {
            commit('auth_error', err)
            commit('showSnackbar', {
              msg: err
            });
            commit('showLoader', false);

            reject(err)
          })
      })
    },
    deleteOnionReport({
      state,
      commit
    }, docId) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            'Authorization': "bearer " + state.token
          }
        };
        var url = `${baseUrl}/api/onion/report/${docId}`
        if (!docId)
          return resolve()
        Axios.delete(url, config)
          .then(resp => {
            if (resp.data.error) {
              commit('showSnackbar', {
                msg: resp.data.msg
              })
              commit('showLoader', false)
            } else {
              resolve(resp)
            }

          })
          .catch(err => {
            commit('auth_error', err)
            commit('showSnackbar', {
              msg: err
            });
            commit('showLoader', false);
            reject(err)
          })
      })
    },
    getOnionComment({
      state,
      commit
    }, docId) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            'Authorization': "bearer " + state.token
          }
        };
        var url = `${baseUrl}/api/onion/comment/${docId}`
        Axios.get(url, config)
          .then(async resp => {
            if (resp.data.error) {
              commit('showSnackbar', {
                msg: resp.data.msg
              })
              commit('showLoader', false)
              return reject()
            }
            commit('getOnionComment', resp.data.data)
            resolve()
          })
          .catch(err => {
            commit('auth_error', err)
            commit('showSnackbar', {
              msg: err
            });
            commit('showLoader', false);

            reject(err)
          })
      })
    },
    postOnionComment({
      state,
      commit
    }, {
      docId,
      data
    }) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            'Authorization': "bearer " + state.token
          }
        };
        var url = `${baseUrl}/api/onion/comment/${docId}`
        Axios.post(url, data, config)
          .then(async resp => {
            if (resp.data.error) {
              commit('showSnackbar', {
                msg: resp.data.msg
              })
              commit('showLoader', false)
              return reject()
            }
            commit('postOnionComment', resp.data.data)
            resolve()
          })
          .catch(err => {
            commit('auth_error', err)
            commit('showSnackbar', {
              msg: err
            });
            commit('showLoader', false);

            reject(err)
          })
      })
    },
  },
  mutations: {
    updateOnionSampleData(state, data) {
      return new Promise(async (res, rej) => {
        if (state.sampleStateData[data.sampleNo - 1]) {
          state.sampleStateData[data.sampleNo - 1] = _.cloneDeep(data.content)
        } else if (!state.sampleStateData[data.sampleNo - 1]) {
          for (let i = state.sampleStateData.length; i < data.sampleNo; i++) state.sampleStateData.push({})
          state.sampleStateData.push(_.cloneDeep(data.content))
        }
        let l = data.sampleNo - 1
        let range = state.sampleStateData[l].sizeDesignation.sizeRange
        if (range != '') {
          let unit = state.sampleStateData[l].sizeDesignation.unit
          let sizeData = state.sampleThresholds.sizeDesignation[unit][range]

          state.sampleStateData[l].sizeDesignation = {
            ...sizeData,
            ...state.sampleStateData[l].sizeDesignation

          }
        }
        for (let key in state.sampleStateData[l].defects) {
          state.sampleStateData[l].defects[key] = {
            ...state.sampleThresholds.defects.defects[key],
            ...state.sampleStateData[l].defects[key]
          }
        }
        for (let key in state.sampleStateData[l].allowance) {
          state.sampleStateData[l].allowance[key] = {
            ...state.sampleThresholds.allowance.values[key],
            ...state.sampleStateData[l].allowance[key]
          }
        }
        res()

      })
    },
    updateOnionSampleThreshold(state, data) {
      state.sampleThresholds = data
    },
    getOnionSummary(state, data) {
      state.reports = _.cloneDeep(data)
    },
    getOnionComment(state, data) {
      state.reportComments = data.reverse()
    },
    postOnionComment(state, data) {
      state.reportComments = [data, ...state.reportComments]
    },
  }
}